// extracted by mini-css-extract-plugin
module.exports = {"hidden":"index_hidden_2F6H_","text-default":"index_text-default_eFVPG","dropdown":"index_dropdown_1TKiR","avatar":"index_avatar_35L7y"};